export default {
  key: 'poissonnerie',
  label: 'Poissonnerie',
  theme: {
    primary: '#376374',
    secondary: '#8AC3D5',
  },
  sections: {
    plu: true,
    contacts: true,
    employees: true,
    fournisseurs: true,
    plateaux: true,
    etiquettes: true,
    retrocession: true,
    tva: true,
    nettoyage: true,
    pms: true,
  },
}
